import axios from 'axios'

const { PAYMENTS_API } = process.env

const apiPayments = axios.create({
    baseURL: PAYMENTS_API,
    withCredentials: true,
    timeout: 200000,
    headers: {
        'Content-Type': 'application/json',
    },
})


export { apiPayments }
